var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 65,
    viewBox: "0 0 97 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2585",
    "data-name": "Group 2585",
    transform: "translate(-1784 -385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 97,
    height: 65,
    rx: 4,
    transform: "translate(1784 385)",
    fill: "#060d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M121.978,42.484v9.495H84V42.484a1.9,1.9,0,1,1,3.8,0v5.7H118.18v-5.7a1.9,1.9,0,1,1,3.8,0ZM92.517,36.516,102.989,42.8l10.472-6.283a1.9,1.9,0,0,0-1.954-3.256l-6.618,3.971V15.9a1.9,1.9,0,0,0-3.8,0V37.231L94.472,33.26a1.9,1.9,0,0,0-1.954,3.256Z",
    transform: "translate(1730 385)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtn);
export default __webpack_public_path__ + "static/media/download-btn.deba82758c1f2c6aeeae78cc25387f8e.svg";
export { ForwardRef as ReactComponent };